import { c as _c } from "react/compiler-runtime";
import React from "react";
import { OTPInput as LibOTPInput, OTPInputContext } from "input-otp";
import { cn } from "@/utils/utils";
interface OTPInputProps {
  length?: number;
  value: string;
  onChange: (otp: string) => void;
  onComplete?: (otp: string) => void;
  error?: string;
  className?: string;
}
function InputOTPGroup(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex items-center gap-3", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div data-slot="input-otp-group" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function InputOTPSlot(t0) {
  const $ = _c(19);
  let className;
  let index;
  let props;
  if ($[0] !== t0) {
    ({
      index,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = index;
    $[3] = props;
  } else {
    className = $[1];
    index = $[2];
    props = $[3];
  }
  const inputOTPContext = React.useContext(OTPInputContext);
  let t1;
  if ($[4] !== index || $[5] !== inputOTPContext?.slots) {
    t1 = inputOTPContext?.slots[index] ?? {};
    $[4] = index;
    $[5] = inputOTPContext?.slots;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    char,
    hasFakeCaret,
    isActive
  } = t1;
  const t2 = isActive && "border-[#037A6A] ring-4 ring-[#037A6A]/10 scale-105";
  let t3;
  if ($[7] !== className || $[8] !== t2) {
    t3 = cn("border border-stone-200 bg-white flex h-12 w-12 items-center justify-center text-xl font-bold text-[#303030] shadow-sm transition-all outline-none rounded-xl", t2, className);
    $[7] = className;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== hasFakeCaret || $[11] !== isActive) {
    t4 = isActive && hasFakeCaret && <div className="w-px h-5 bg-black animate-blink" />;
    $[10] = hasFakeCaret;
    $[11] = isActive;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== char || $[14] !== isActive || $[15] !== props || $[16] !== t3 || $[17] !== t4) {
    t5 = <div data-slot="input-otp-slot" data-active={isActive} className={t3} {...props}>{char}{t4}</div>;
    $[13] = char;
    $[14] = isActive;
    $[15] = props;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
const OTPInput: React.FC<OTPInputProps> = t0 => {
  const $ = _c(17);
  const {
    length: t1,
    value,
    onChange,
    onComplete,
    error,
    className: t2
  } = t0;
  const length = t1 === undefined ? 6 : t1;
  const className = t2 === undefined ? "" : t2;
  let t3;
  if ($[0] !== length || $[1] !== onChange || $[2] !== onComplete) {
    t3 = newValue => {
      onChange(newValue);
      if (newValue.length === length && onComplete) {
        onComplete(newValue);
      }
    };
    $[0] = length;
    $[1] = onChange;
    $[2] = onComplete;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleOtpChange = t3;
  const t4 = `flex flex-col items-center ${className}`;
  let t5;
  if ($[4] !== length) {
    t5 = Array.from({
      length
    });
    $[4] = length;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== error || $[7] !== t5) {
    t6 = <InputOTPGroup>{t5.map((_, index) => <InputOTPSlot key={index} index={index} className={cn("size-10", error && "border-[#C00F0C] focus-visible:ring-[#C00F0C]")} />)}</InputOTPGroup>;
    $[6] = error;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== handleOtpChange || $[10] !== length || $[11] !== t6 || $[12] !== value) {
    t7 = <LibOTPInput value={value} maxLength={length} pattern={"\\d*"} autoComplete="one-time-code" spellCheck={false} aria-label="One-time password" autoFocus={true} onChange={handleOtpChange} containerClassName="flex items-center gap-2" className="disabled:cursor-not-allowed">{t6}</LibOTPInput>;
    $[9] = handleOtpChange;
    $[10] = length;
    $[11] = t6;
    $[12] = value;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default OTPInput;